import { stats, testimonials } from "@/mocks/videos";

export default function StatsSection() {
  return (
    <section className="w-full bg-background-50 py-14 md:py-20 px-4 md:px-6">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8 mb-16">
          {stats.map((stat, index) => (
            <div
              key={index}
              className="text-center p-6 rounded-xl bg-background-100/70 border border-background-200/60"
            >
              <div className="w-12 h-12 mx-auto mb-3 flex items-center justify-center rounded-full bg-primary-100 text-primary-500">
                <i className={`${stat.icon} text-xl`}></i>
              </div>
              <div className="text-2xl md:text-3xl font-heading text-primary-500 mb-1">
                {stat.value}
              </div>
              <div className="text-sm text-foreground-600">{stat.label}</div>
            </div>
          ))}
        </div>

        <div>
          <div className="text-center mb-10">
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-3">
              用户好评如潮
            </h2>
            <p className="text-foreground-600 text-sm max-w-lg mx-auto">
              来自真实用户的使用反馈，久久视频用心服务每一位观众
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
            {testimonials.map((item, index) => (
              <div
                key={index}
                className="p-5 rounded-xl bg-background-100/70 border border-background-200/60"
              >
                <div className="flex items-center gap-3 mb-3">
                  <img
                    src={item.avatar}
                    alt={item.name}
                    className="w-10 h-10 rounded-full object-cover"
                    loading="lazy"
                  />
                  <div>
                    <div className="text-sm font-medium text-foreground-900">{item.name}</div>
                    <div className="flex gap-0.5 mt-0.5">
                      {Array.from({ length: item.rating }).map((_, i) => (
                        <i key={i} className="ri-star-fill text-accent-500 text-xs"></i>
                      ))}
                    </div>
                  </div>
                </div>
                <p className="text-sm text-foreground-600 leading-relaxed">{item.comment}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}